module.exports = __webpack_public_path__ + "static/media/consulting.8db6f472.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/consulting.jpeg
// module id = 1602
// module chunks = 0